// src/features/patientinfo/patentInfoSelectors.ts

import { RootState } from "@core/store"

export const hospitalInfoSelector = (state: RootState) => state.hospital.hospitalinfo
export const hospitalinfoLoadingSelector = (state: RootState) => state.hospital.hospitalinfoLoading
export const hospitalinfoErrorSelector = (state: RootState) => state.hospital.hospitalinfoError

export const buhangcupSelector = (state: RootState) => state.hospital.buhangcup

export const loadingSelector = (state: RootState) => state.hospital.loading

export const errorSelector = (state: RootState) => state.hospital.error

// 서버 버전 셀렉터
export const serverVersionSelector = (state: RootState) => state.hospital.serverVersion
